































































































































































































































































































import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeDataAgendamentoStore from '@/components/Backoffice/Store/BackofficeDataAgendamentoStore'

import { CoreBase, Triagem } from '@/types/core'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage, getWeekdayByDate, maskDate, maskHour, timeoutDefault } from '@/utils/common'
import moment from 'moment'
import { buildSurgerySchedulingLimitParams, getInvalidSchedulingDates, InvalidSchedulingDate, isInvalidSchedulingDate } from '@/services/surgery-scheduling-limit.service'

@Component
export default class ComponentModalConfirm extends Vue {
  $refs!: {
    dataAgendamentoForm: any,
    agendamentoChat: any,
    dateA: any,
    surgeryDatePicker: any,
  }

  today: string = new Date().toISOString()

  dataAgendamentoForm: any = {
    valid: true,
    dataAgendamento: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
    ],
    numeroReserva: [
      v => !!v || 'O campo número da reserva é obrigatório.',
    ],
    dataVirtual: [
      v => (v !== undefined && v !== null && v !== '') || 'O campo data virtual é obrigatório.',
    ],
  }

  modalHeight: number = 0
  loadNumeroReserva: boolean = false
  loadConfirmar: boolean = false
  loadVoltar: boolean = false
  numeroReserva: string = ''
  dateText1: string = ''
  coreBase: CoreBase.ICoreBase = new CoreBase.CoreBase()
  triagem: Triagem.ITriagem = new Triagem.Triagem()
  invalidSchedulingDates: InvalidSchedulingDate[] = []

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getDateText1() {
    this.dateText1 = this.formatISOToDate(this.getDataAgendamentoStore.agendamentoItem.dataAgendamento)
    return this.dateText1
  }

  set getDateText1(value: string) {
    this.dateText1 = this.formatISOToDate(this.getDataAgendamentoStore.agendamentoItem.dataAgendamento)
  }

  get surgeryWeekday() {
    const { dataAgendamento } = this.getDataAgendamentoStore.agendamentoItem

    return dataAgendamento ? getWeekdayByDate(dataAgendamento) : ''
  }

  get surgeryDate() {
    const date = this.getDataAgendamentoStore.agendamentoItem.dataAgendamento

    if (date) {
      const formats = [
        'YYYY-MM-DDTHH:mm:ss.SSSZ',
        'YYYY-MM-DDTHH:mm:ss',
        'YYYY-MM-DDTHH:mm',
        moment.ISO_8601,
      ]

      const parsed = moment(date, formats, true)

      return parsed.isValid() ? parsed.toDate() : null
    }

    return null
  }

  set surgeryDate(newDate) {
    if (newDate) {
      const parsed = moment(newDate)

      this.getDataAgendamentoStore.agendamentoItem.dataAgendamento = parsed.isValid()
        ? parsed.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        : ''
    } else {
      this.getDataAgendamentoStore.agendamentoItem.dataAgendamento = ''
    }
  }

  get minimumSchedulingDate() {
    const todayDate = new Date(Date.now())
    todayDate.setMonth(todayDate.getMonth() - 3)

    return todayDate.toISOString()
  }

  get minimumSchedulingDateTime() {
    return this.minimumSchedulingDate
  }

  get surgeryDateInputProps() {
    return {
      textInput: this.textFieldInputProps,
      datePickerInput: this.datePickerInputProps,
      timePickerInput: this.timePickerInputProps,
    }
  }

  get textFieldInputProps() {
    return {
      hint: this.surgeryWeekday,
      persistentHint: true,
      rules: this.dataAgendamentoForm.dataAgendamento,
      readonly: true,
      appendIcon: 'event',
    }
  }

  get datePickerInputProps() {
    const invalidSchedulingDates = this.invalidSchedulingDates.reduce((dateMap, item) => {
      dateMap[item.data] = true
      return dateMap
    }, {})

    return {
      min: this.minimumSchedulingDate,
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      allowedDates: date => !invalidSchedulingDates[date],
    }
  }

  get timePickerInputProps() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      allowedMinutes: m => m % 15 === 0,
    }
  }

  get showModalConfirmarDataAgendamento() {
    return this.getDataAgendamentoStore.modal.confirmarDataAgendamento
  }

  set showModalConfirmarDataAgendamento(value: boolean) {
    this.$refs.dataAgendamentoForm.resetValidation()
    this.getDataAgendamentoStore.setModal({ name: 'confirmarDataAgendamento', value })
  }

  get getNumeroReserva() {
    return this.numeroReserva
  }

  set getNumeroReserva(value: string) {
    this.numeroReserva = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingVoltar() {
    return this.loadVoltar
  }

  set loadingVoltar(value: boolean) {
    this.loadVoltar = value
  }

  get loadingNumeroReserva() {
    return this.loadNumeroReserva
  }

  set loadingNumeroReserva(value: boolean) {
    this.loadNumeroReserva = value
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getDataAgendamentoStore() {
    return getModule(BackofficeDataAgendamentoStore, this.$store)
  }

  get hasSelectedInvalidSchedulingDate() {
    return isInvalidSchedulingDate(this.invalidSchedulingDates, this.getDataAgendamentoStore.agendamentoItem.dataAgendamento)
  }

  isSchedulingDateOptionDisabled(date: string) {
    return !date || isInvalidSchedulingDate(this.invalidSchedulingDates, date)
  }

  notifyInvalidSchedulingDate() {
    EventBus.$emit('setSnackbar', getSnackbarMessage('A data selecionada não é válida para o agendamento dessa cirurgia. Por favor, escolha outra data.', 'error'))
  }

  clearSelectedSchedulingDate(parent?) {
    this.getDataAgendamentoStore.agendamentoItem.dataAgendamento = ''

    if (parent && parent.clearHandler) {
      parent.clearHandler()
      return
    }

    if (this.$refs.surgeryDatePicker && this.$refs.surgeryDatePicker.clearHandler) {
      this.$refs.surgeryDatePicker.clearHandler()
    }
  }

  syncSelectedSchedulingDateWithLimit() {
    if (this.hasSelectedInvalidSchedulingDate) {
      this.notifyInvalidSchedulingDate()

      this.$nextTick(() => {
        this.clearSelectedSchedulingDate()
      })
    }
  }

  async refreshInvalidSchedulingDates() {
    this.invalidSchedulingDates = []

    const params = buildSurgerySchedulingLimitParams({
      shouldCheck: !!this.getBackofficeGlobalStore.solicitacao.acoes.verificaLimitadorDeCirurgia,
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      complexity: this.getBackofficeGlobalStore.solicitacao.complexidade,
    })

    if (params) {
      this.invalidSchedulingDates = await getInvalidSchedulingDates(params)
      this.syncSelectedSchedulingDateWithLimit()
    }
  }

  onSelectedSchedulingDateChange() {
    this.syncSelectedSchedulingDateWithLimit()
  }

  clickDateTime(event) {
    if (!this.getDataAgendamentoStore.agendamentoItem.dataAgendamento) {
      this.getDataAgendamentoStore.agendamentoItem.dataAgendamento = moment(new Date()).format('YYYY-MM-DDT12:00')
    }

    this.$refs.dateA.open(event)
  }

  clearDate() {
    this.clearSelectedSchedulingDate()
  }

  formatISOToDate(value: string | Date) {
    if (value === '') return value
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  formatHour(date: string) {
    return maskHour(date)
  }

  async confirmar() {
    this.loadingConfirmar = true
    let solicitacaoId = this.getDataAgendamentoStore.agendamentoItem.id

    if (await this.$refs.dataAgendamentoForm.validate()
      && await this.checkNumeroReserva(this.getDataAgendamentoStore.agendamentoItem.numeroAgendamento)) {
      const params: any = {
        solicitacaoId,
        dataAgendamento: this.getDataAgendamentoStore.agendamentoItem.dataAgendamento,
        dataAgendamentoVirtual: this.getDataAgendamentoStore.agendamentoItem.dataAgendamentoVirtual,
        numeroAgendamento: this.getDataAgendamentoStore.agendamentoItem.numeroAgendamento,
      }

      if (this.$refs.agendamentoChat.getMensagem) {
        this.$refs.agendamentoChat.send()
      }

      const response = await this.triagem.confirmarDataAgendamento(params)

      if (response.success) {
        params.confirmarData = false
        params.alterarData = true
        this.getBackofficeAgendamentoStore.setDataConfirmadaAgendamento(params)

        if (this.getBackofficeGlobalStore.mapaCirurgicoAlterarReserva) {
          EventBus.$emit('updateItensMapaCirurgico', true)
        } else {
          await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
        }

        await this.closeModal()
        EventBus.$emit('setSnackbar', { show: true, text: 'Data confirmada com sucesso.', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao confirmar a data do agendamento.', icon: 'warning', color: '#C62828' })
      }
    }
    solicitacaoId = ''
    this.loadingConfirmar = false
  }

  async voltar() {
    this.loadingVoltar = true
    await timeoutDefault()
    await this.closeModal()
    this.loadingVoltar = false
  }

  async closeModal() {
    let solicitacaoId = this.getDataAgendamentoStore.agendamentoItem.id || this.getBackofficeGlobalStore.solicitacao.id
    if (this.getBackofficeGlobalStore.desfazCancelamento) {
      await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
      this.getBackofficeGlobalStore.setDesfazCancelamento(false)
      this.guiaCanceladaNaOperadora = false
    }
    this.showModalConfirmarDataAgendamento = false
    this.clearSelectedSchedulingDate()
    this.invalidSchedulingDates = []
    this.getDataAgendamentoStore.clearAgendamentoItem()
    this.$refs.dataAgendamentoForm.resetValidation()
    this.getNumeroReserva = ''

    if (this.getBackofficeGlobalStore.mapaCirurgicoAlterarReserva) {
      const { id } = this.getBackofficeGlobalStore.solicitacao
      await this.getBackofficeGlobalStore.desbloquearSolicitacao(id)
      this.getBackofficeGlobalStore.clearSolicitacao()
      this.getBackofficeGlobalStore.setMapaCirurgicoAlterarReserva(false)
    }
    solicitacaoId = ''
    this.showModalConfirmarDataAgendamento = false
  }

  async checkNumeroReserva(numeroReserva: string) {
    this.loadingNumeroReserva = true
    this.getNumeroReserva = ''
    if (numeroReserva) {
      const params: any = {
        solicitacaoId: this.getDataAgendamentoStore.agendamentoItem.id,
        numeroReserva,
        hospitalId: this.getDataAgendamentoStore.agendamentoItem.hospitalId,
      }

      const response = await this.coreBase.getCheckNumeroReserva(params)
      this.loadingNumeroReserva = false

      if (!response.success) {
        this.getNumeroReserva = ''
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro na validação no número de reserva.', icon: 'warning', color: '#C62828' })
        return false
      }

      if (response.success && response.data) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Número de reserva duplicado.', icon: 'warning', color: '#C62828' })
        this.getNumeroReserva = 'Número de reserva duplicado.'
        return false
      }
      return true
    }

    this.getNumeroReserva = 'O campo número da reserva é obrigatório.'
    this.loadingNumeroReserva = false
    return false
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('main-chat-scroll')
    const option: ScrollToOptions = {
      behavior: 'smooth',
      left: 0,
      top: ele[0].scrollHeight + 200,
    }
    ele[0].scrollTo(option)
  }

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      const documentHeight = doc.documentElement.clientHeight
      const documentWidth = doc.documentElement.clientWidth
      const modalContent = (doc.querySelector('.modal-content') as HTMLDivElement).scrollHeight
      const modalHeader = (doc.querySelector('.modal-header') as HTMLDivElement).scrollHeight
      const modalBodyHeader = (doc.querySelector('.modal-body-header') as HTMLDivElement).scrollHeight
      const modalFooter = (doc.querySelector('.modal-footer') as HTMLDivElement).scrollHeight
      const modalChatSend = (doc.querySelector('.main-chat__send') as HTMLDivElement).scrollHeight
      const modalChatBox = (doc.querySelector('.chat-box') as HTMLDivElement).scrollHeight
      const variation = documentWidth >= 355 ? 99 : 109
      const result = modalContent - modalHeader - modalBodyHeader - modalFooter - variation
      this.modalHeight = modalBodyHeader < 130 ? Math.abs(result) : 175
    } else {
      this.modalHeight = 0
    }
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      this.getWindowHeight()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      this.getWindowHeight()
    })
    this.scrollToMensagem()
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowHeight)
  }

  @Watch('showModalConfirmarDataAgendamento')
  async onChangeShowModalConfirmarDataAgendamento(opened: boolean) {
    if (opened) {
      await this.refreshInvalidSchedulingDates()
    } else {
      this.invalidSchedulingDates = []
      this.dateText1 = ''
    }
  }

  templateMessage = {
    icon: 'mdi-close-circle-outline',
    message: 'Ocorreu um erro ao preencher o formulário...',
    color: 'red darken-2',
  }

  guiaCancelada: boolean = false
  errModal: boolean = false
  get guiaCanceladaNaOperadora() { return this.guiaCancelada }
  set guiaCanceladaNaOperadora(value: boolean) { this.guiaCancelada = value }
  get errorModal() { return this.errModal }
  set errorModal(value: boolean) { this.errModal = value }

  confereCamposParaDesfazerCancelamento() {
    const errors: string[] = []
    const { numeroAgendamento, dataAgendamento } = this.getDataAgendamentoStore.agendamentoItem

    if (['', null, undefined].includes(dataAgendamento)) {
      errors.push('É necessário informar uma data da cirurgia.')
    } else {
      const diff = moment(new Date().toISOString()).diff(moment(new Date(dataAgendamento).toISOString()))
      if (moment.duration(diff).asDays() > 0) errors.push('É necessário escolher uma data futura.')
    }

    if (['', null, undefined].includes(numeroAgendamento)) errors.push('É necessário informar um número de reserva.')

    return errors
  }

  async backofficeAgendamentoDesfazCancelamento() {
    this.loadingConfirmar = true

    if (this.confereCamposParaDesfazerCancelamento().length > 0) {
      this.errorModal = true
    } else {
      const params: any = {
        solicitacaoId: this.getDataAgendamentoStore.agendamentoItem.id,
        guiaCanceladaNaOperadora: this.guiaCanceladaNaOperadora,
        reservaData: {
          solicitacaoId: this.getDataAgendamentoStore.agendamentoItem.id,
          dataAgendamento: this.getDataAgendamentoStore.agendamentoItem.dataAgendamento,
          dataAgendamentoVirtual: this.getDataAgendamentoStore.agendamentoItem.dataAgendamentoVirtual,
          numeroAgendamento: this.getDataAgendamentoStore.agendamentoItem.numeroAgendamento,
        },
      }

      const request = await this.getBackofficeGlobalStore.backofficeAgendamentoDesfazCancelamento(params)
      if (request.success) {
        EventBus.$emit('setSnackbar', { show: true, text: `Cancelamento desfeito com sucesso. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message ? `${request.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um problema ao desfazer o cancelamento. ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false
  }
}
